import { render, staticRenderFns } from "./UpdateUserAvatarDialog.vue?vue&type=template&id=b2843f58"
import script from "./UpdateUserAvatarDialog.vue?vue&type=script&lang=js"
export * from "./UpdateUserAvatarDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateUserAvatarDialog.vue?vue&type=style&index=0&id=b2843f58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports